module.exports = __webpack_public_path__ + "img/cloud1_2.07cf52d4.png";